/* eslint-disable @typescript-eslint/ban-ts-comment */
import Input from "../../Shared/Input";
import ImgPlaceholder from "../../../assets/ImgPlaceholder.svg";
import PencilIcon from "../../Icons/PencilIcon";
import Button from "../../Shared/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../../utils/consts";
import AddIcon from "../../Icons/AddIcon";
import UploadProfile from "../../Shared/UploadProfile";
import { queryClient } from "../../../main";
import { toast } from "react-toastify";
import { AddTeam } from "../../../api/Team/AddTeamMember";
import TextArea from "../../Shared/TextArea";
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  img_url: Yup.string().required("Photo is required"),

});

const AddNewMember = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { mutate , error } = useMutation({
    mutationFn: AddTeam,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["teams"] });
      toast.success("Team member added successfully");
      formik.resetForm();
      onSuccess && onSuccess();
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      img_url: "",
      email: "",
      description:"",
      title: "",
    },
    validationSchema,
    onSubmit: (values) => {
      //@ts-ignore
      mutate(values);
    },
  });
  const handleimgUrlUpload = (url: string) => {
    formik.setFieldValue('img_url', url);
  };

  return (
    <div className="py-7">
      <h1 className="text-burntBlack font-bold text-[32px] mb-7">Profile</h1>
      <div className="p-8 rounded-xl bg-white border-black/15 shadow flex flex-col justify-end pt-40">
        <form onSubmit={formik.handleSubmit} className="flex gap-12">
          <div className="relative size-[132px] rounded-full object-cover cursor-pointer">
            <UploadProfile folder="team_image" onFileUploaded={handleimgUrlUpload}>
              <div className="absolute z-50 right-0 w-8 h-8 bg-[#2783E9] rounded-full flex items-center justify-center bottom-7">
                <PencilIcon />
              </div>
              {formik.values.img_url && formik.values.img_url !== "" && formik.values.img_url !== "uploading" ? (
                <img className="rounded-full size-[110px] object-cover" src={formik.values.img_url} />
              ) : (
                <img className="rounded-full size-[110px] object-cover" src={ImgPlaceholder} />
              )}            
              </UploadProfile>
          </div>
          <div className="w-full space-y-5">
            <div className="flex gap-7 w-full">
              <Input
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.name && formik.errors.name
                    ? formik.errors.name
                    : ""
                }
                className="w-full"
                title="Full Name"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="name"
                placeholder=""
              />
            </div>
            <div className="flex gap-7 w-full">
              <Input
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.email && formik.errors.email
                    ? formik.errors.email
                    : ""
                }
                className="w-full"
                title="Email"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="email"
                placeholder=""
              />
              <Input
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.title && formik.errors.title
                    ? formik.errors.title
                    : ""
                }
                className="w-full"
                title="Title"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="title"
                placeholder=""
              />
            </div>
            <TextArea
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.description && formik.errors.description
                    ? formik.errors.description
                    : ""
                }
                className="w-full"
                inputStyles="h-32  !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                title="Description"
                name="description"
                placeholder=""
              />

            <Button
              className="!h-12 w-44 !text-sm font-bold rounded-md ml-auto !bg-[#4379EE] hover:!bg-primary"
              variant="primary"
              type={ButtonTypes.SUBMIT}
            >
              <AddIcon className="mr-1.5" />
              Add Team Member
            </Button>
            {error instanceof AxiosError && (
                    <span className="text-red-500 font-bold text-lg">
                        {error?.response?.data?.message || "An error occurred"}
                    </span>
                )}

          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNewMember;
